import { useStaticQuery, graphql } from "gatsby"

export const useCommonItemsQuery = () => {
  const { wp } = useStaticQuery(
    graphql`
      query CommonItemsQuery {
        wp {
          acfOptionsCommonItems {
            commonitems {
              commonItemsCalloutLargerText
              commonItemsCalloutSubheading
              commonItemsCaseResultSidebarHeading
              commonItemsCopyrightText
              commonItemsFax
              commonItemsHeaderButtonText
              commonItemsHeaderTextBlack
              commonItemsHeaderTextRed
              commonItemsOffices {
                commonItemsAddress
                commonItemsGoogleMapsLink {
                  url
                }
                commonItemsPhone
                commonItemsTitle
              }
              commonItemsSidebarFormHeading
              commonItemsSidebarMenuTitle
              commonItemsSidebarMenuTitleLink {
                url
              }
              commonItemsSocialLinks {
                commonItemsIcon {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(formats: [AUTO, WEBP, AVIF])
                    }
                  }
                }
                commonItemsLink {
                  url
                }
              }
              commonItemsTextAbovePhoneNumberInHeader
              commonItemsTopBarTextMobile
              commonItemsTopBarTextWhite
              commonItemsTopBarTextYellow
              commonItemsBlogHeroImageAltText
              commonItemsPageSubtitle
              commonItemsInteriorVideoTitle
              commonItemsInteriorVideoSubtitle
              commonItemsBlogHeroTitle
              commonItemsBlogHeroImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      layout: FULL_WIDTH
                      formats: [AUTO, WEBP, AVIF]
                    )
                  }
                }
              }
            }
          }
        }
      }
    `
  )
  return wp.acfOptionsCommonItems.commonitems
}
